module.exports = __webpack_public_path__ + "img/6.85a8a684.png";